const desktopMQ = window.matchMedia("(min-width: 768px)");

function enableDesktopHoverMenu() {
  if (window.__desktopHoverMenuEnabled) return;
  window.__desktopHoverMenuEnabled = true;

  document.querySelectorAll("details").forEach((details) => {
    const summaryItem = details.querySelector(".list-menu__item");
    const submenu = details.querySelector(".header__submenu");
    if (!summaryItem || !submenu) return;

    summaryItem.addEventListener("mouseenter", () => details.setAttribute("open", ""));
    submenu.addEventListener("mouseenter", () => details.setAttribute("open", ""));
    details.addEventListener("mouseleave", () => details.removeAttribute("open"));
  });
}

function disableDesktopHoverMenu() {
  // We can't easily remove anonymous listeners; easiest:
  // just remove open state so mobile works properly
  window.__desktopHoverMenuEnabled = false;
  document.querySelectorAll("details[open]").forEach((d) => d.removeAttribute("open"));
}

function handleMenuByScreen(e) {
  if (e.matches) {
    enableDesktopHoverMenu();
  } else {
    disableDesktopHoverMenu();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  handleMenuByScreen(desktopMQ);
});

desktopMQ.addEventListener("change", handleMenuByScreen);


// button toggle hover effect for product description

document.addEventListener('DOMContentLoaded', () => {
  const desc = document.querySelector('.product__description.rte');
  const btn  = document.querySelector('.desc-toggle-btn');

  if (!desc || !btn) return;

  const collapsedHeight = 240; // same as CSS collapsed max-height

  // Start collapsed
  desc.classList.add('is-collapsed');
  desc.style.maxHeight = collapsedHeight + "px";

  // Hide button if no overflow
  if (desc.scrollHeight <= collapsedHeight + 5) {
    btn.style.display = "none";
    desc.classList.remove('is-collapsed');
    desc.style.maxHeight = "none";
    return;
  }

  btn.addEventListener('click', () => {
    const isCollapsed = desc.classList.contains('is-collapsed');

    if (isCollapsed) {
      // Expand smoothly
      desc.classList.remove('is-collapsed');
      desc.style.maxHeight = desc.scrollHeight + "px";
      btn.textContent = "View Less";
      btn.setAttribute("aria-expanded", "true");
    } else {
      // Collapse smoothly
      desc.classList.add('is-collapsed');
      desc.style.maxHeight = collapsedHeight + "px";
      btn.textContent = "View More";
      btn.setAttribute("aria-expanded", "false");
    }
  });
});

// for shoppable video audio functionality
document.querySelectorAll(".sv-miniCard").forEach((item,index)=>{
  item.addEventListener("click",()=>{
   
  })
})

